import React from 'react'
import './StudentList.scss'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { selectAllStudents, clearSelectedStudents, toggleStudent } from '../tutorAssignmentSlice/tutorAssignmentSlice';
import ReactTooltip from 'react-tooltip';

export default function StudentList({assignments, roster}) {
  const dispatch = useDispatch();
  const selectedStudents = useSelector((state) => state.tutorAssignment?.selectedStudents ?? []);
  const studentData = roster?.data?.student ?? [];

  const studentsWithActiveTutor = studentData.filter(student => {
    const studentAssignment = assignments.find(a => a.entityId === student.id);
    return studentAssignment?.assignments?.some(assignment =>
      assignment.status === "ASSIGNED" || assignment.status === "IN_PROGRESS"
    );
  }).map(student => student.id);

  const studentsWithoutActiveTutorAssignment = studentData.filter(student => !studentsWithActiveTutor.includes(student.id));

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      dispatch(selectAllStudents(studentsWithoutActiveTutorAssignment.map(student => student.id)));
    } else {
      dispatch(clearSelectedStudents());
    }
  }

  const handleStudentSelect = (studentId) => {
    dispatch(toggleStudent(studentId));
  }

  const allAvailableStudents = () => {
    return studentsWithoutActiveTutorAssignment.length > 0 &&
      studentsWithoutActiveTutorAssignment.every(student =>
        selectedStudents.includes(student.id)
      );
  }

  return (
    <div className='tutor-assignment-modal__students'>
      <h3 className='tutor-assignment-header'>Assign To</h3>

      <div className='tutor-assignment-student-list'>
        <div className='tutor-assignment-student-list__select-all'>
          <input
            className="student-checkbox"
            type="checkbox"
            checked={allAvailableStudents()}
            onChange={handleSelectAll}
          />
          <span>Select All Students</span>
        </div>
        <div className='tutor-assignment-student-list__container'>
          <ul className="tutor-assignment-student-list__items">
              {studentData.map((student) => {
                const hasActiveTutor = studentsWithActiveTutor.includes(student.id);
                return (
                  <li
                    key={student.id}
                    className={`tutor-assignment-student-list__item ${hasActiveTutor ? 'disabled' : ''}`}
                  >
                    <input
                      className="student-checkbox"
                      type="checkbox"
                      checked={selectedStudents.includes(student.id)}
                      onChange={() => handleStudentSelect(student.id)}
                      disabled={hasActiveTutor}
                    />
                    <span
                      data-tip={hasActiveTutor ? 'This student already has a story that is assigned or in progress.' : ""}
                      data-for={`student-tooltip-${student.id}`}
                    >
                      {student.last_name}, {student.first_name}
                    </span>
                    {hasActiveTutor && (
                      <ReactTooltip
                        id={`student-tooltip-${student.id}`}
                        effect="solid"
                        className="story-modal-tooltip"
                      />
                    )}
                  </li>
                );
              })}
            </ul>
        </div>
      </div>
    </div>
  )
}